import $ from 'jquery'

export let url;
export let ENTID = 2038; //正式版企业id
export let COMID = 3526 //正式版公司id
// export let COMID = 2882; //tok
let host = window.location.host
let protocol = window.location.protocol

// 開發環境
if (host.indexOf('1ecst') === -1) {
  url = 'http://tok.1ecst.com/tp_ecst'

  if (host.indexOf('income-team') > -1) {
    url = 'https://www.1ecst.com/tp_ecst'
  }
  // ENTID = 1564; //tok
  // COMID = 2882; //tok
  // https://order.income-team.com
  // url = 'http://www.1ecst.com/tp_ecst'
}
else {
  url = protocol + '//' + host + '/tp_ecst'
  if (host.indexOf('tok') > -1) {
    // ENTID = 1564; //tok
    // COMID = 2882; //tok
    // url = 'http://www.1ecst.com/tp_ecst'
  }
  // url = 'http://tok.1ecst.com/tp_ecst'
  // url = 'http://tqc.1ecst.com/tp_ecst'
  // url = 'http://www.1ecst.com/tp_ecst'
}

const userEac = /^\d{1,}$/;
const emilnEac = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;


export function getLocahost() {
  let data = JSON.parse(localStorage.getItem('logindata'));
  if (data) {
    return data
  }
  else {
    return '';
  }
}

export function getLocahost_key(key) {
  let data = JSON.parse(localStorage.getItem(key));
  if (data) {
    return data
  }
  else {
    return {};
  }
}


// 账号退出函数
export function logout() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/logout',
      type: 'post',
      dataType: 'jsonp',
      data: {
        "uid": Number.parseInt(getLocahost().user_id),
        "compid": COMID,
        "scoket": getLocahost().socket
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 窗帘账号退出函数
export function curtainlogout() {
  return new Promise((resolve, reject) => {
    resolve()
    // $.ajax({
    //   url:url+'/index.php/Api2/Ecustomers/logout',
    //   type:'post',
    //   dataType:'jsonp',
    //   data:{
    //     "uid":Number.parseInt(getLocahost().user_id),
    //     "compid":COMID,
    //     "scoket":getLocahost().socket
    //   },
    //   success:function (data) {
    //     resolve(data)
    //   }
    // })
  })
}

export function cheacksocket() {
  alert('The user has failed, please log in again')
  localStorage.removeItem('dukeuUserID')
  localStorage.removeItem('LocalShoppingCart')
  window.open('login.html', '_self')
}

// 获取url参数函数封装
export function getUrlParameter(key) {
  let urlarr = location.search.substring(1).split('&')
  for (let i = 0; i < urlarr.length; i++) {
    if (key === urlarr[i].split('=')[0]) {
      return urlarr[i].split('=')[1]
    }
  }
}

// 获取导航接口
export function nav() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/webNavigation',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 获取广告
export function getBanners() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getBanner',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID,
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 获取安裝位置底部图片
export function getWebsiteCompanyBottomPic() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getWebsiteCompanyBottomPic',
      type: 'get',
      dataType: 'jsonp',
      data: {
        comid: COMID,
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 获取服务列表
export function getserviceList() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/serviceList',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'comid': COMID,
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 获取某个产品的详情
export function getProDetail(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getProDetail',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID,
        pid: Number.parseInt(id),
        'website_type': 'dentist'
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 获取手机区号
export function getCode() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getCode',
      type: 'post',
      dataType: 'jsonp',
      data: {
        compid: COMID,
      },
      success: function (data) {
        resolve(data)
      }
    })
  })
}

// 注册ecst系统后台短信验证码
export function ecstsendPhoneCode(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/Users/sendPhoneCode",
      async: false,
      dataType: 'jsonp',
      data: {
        // "compid": COMID,
        "flag": true,
        "region": Number.parseInt(data.region), //区号
        "phone": Number.parseInt(data.phone),
        "status": 'setCode', //验证码
        "type": data.type //验证码
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}


// 注册ecst系统后台新用户
export function ecstregisterForm(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/Users/registerForm",
      async: false,
      dataType: 'jsonp',
      data: {
        // "compid": COMID,
        "flag": true,
        "enterprise": data.enterprise,
        "username": data.username,
        "clinic": data.clinic, //诊所名称
        "dentist_mame": data.dentist_mame, //醫生名称
        "fax": data.fax, //传真
        "tel": data.tel, //电话
        "address": data.address, //地址
        "technician_name": data.technician_name, //請填寫技術員名稱
        "technician_seniority": data.technician_seniority, //請填寫技術員年資
        "phone": Number.parseInt(data.phone),
        "region": Number.parseInt(data.region), //区号
        "password": data.password,
        "repassword": data.password,
        "email": data.email,
        "smsCode": data.smsCode, //验证码
        "type": 1, //註冊時要為用戶綁定客戶公司和創建聯絡人
        "users_role": data.users_role, //角色
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 登录ecst系统后台
export function ecstloginForm(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/Users/loginForm",
      async: false,
      dataType: 'jsonp',
      data: {
        // "compid": COMID,
        "flag": true,
        "enterprise_name": data.enterprise,
        "username": data.username,
        "password": data.password,
        "verify": data.verify, //图片验证码
        "hidden": 1, //不需要验证码登录
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 登录ecst系统后台
export function Api2_ecstloginForm(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Users/loginForm",
      async: false,
      dataType: 'json',
      data: {
        "enterprise": data.enterprise,
        "username": data.username,
        "password": data.password,
        "hidden": 1, //不需要验证码登录
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// ecst系统后台忘记密码
export function ecstmodifyPw(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/Users/modifyPw",
      async: false,
      dataType: 'jsonp',
      data: {
        // "compid": COMID,
        "flag": true,
        "backPhone": Number.parseInt(data.phone),
        "backRegion": Number.parseInt(data.region), //区号
        "resetPwd": data.password,
        "resetPwd2": data.password,
        "backCode": data.smsCode, //验证码
        "backUid": data.backUid //用户id
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 检测用户是否已经注册 以及获取手机验证码
export function checkuser(user, code) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/checkIfExists",
      async: false,
      dataType: 'jsonp',
      data: {
        "compid": COMID,
        "phnum": Number.parseInt(user),
        "code": Number.parseInt(code),
      },
      success: function (datas) {
        if (datas.status) {
          // 用户未注册，获取手机验证码
          $.ajax({
            type: "post",
            url: url + "/index.php/Api2/Ecustomers/ajaxGetConfirmCode",
            async: false,
            dataType: 'jsonp',
            data: {
              "compid": COMID,
              "phonenumber": Number.parseInt(user),
              "regionnum": Number.parseInt(code),
            },
            success: function (data) {
              resolve(data)
            }
          })
        }
        else {
          reject(datas)
        }
      },
      error: function (err) {
        reject(err)
      }
    })
  })
}


// 获取手机找回密码的验证码
export function phonecode(user, code) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/ajaxGetConfirmCode",
      async: false,
      dataType: 'jsonp',
      data: {
        "compid": COMID,
        "phonenumber": Number.parseInt(user),
        "regionnum": Number.parseInt(code),
        'type': 1
      },
      success: function (data) {
        if (data.status) {
          resolve(data)
        }
      }
    })
  })
}

// 手机注册
export function register(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/ajaxRegisterUsers",
      async: false,
      dataType: 'jsonp',
      data: {
        "compid": COMID,
        "phonenumber": Number.parseInt(data.user),
        "regionnum": Number.parseInt(data.areaCode), //区号
        "password": data.password,
        "confirmpassword": data.password,
        "confirmcode": data.code //验证码
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 邮箱注册
export function emailRegisterUser(data, type) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/emailRegisterUser",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "email": data.email,
        "password": data.password,
        "confirmpassword": data.password2,
        "code": data.code,
        "type": type
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

//手机找回密码
export function phoneItpassword(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/findPassword",
      async: false,
      dataType: 'jsonp',
      data: {
        "compid": COMID,
        "phonenumber": Number.parseInt(data.user),
        "regionnum": Number.parseInt(data.areaCode),
        "password": data.password,
        "confirmpassword": data.password,
        "confirmcode": data.code
      },
      success: function (data) {
        if (data.status) {
          resolve(data)
        }
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 获取邮箱注册的验证码
export function sendEmailCode(email, type) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/sendEmailCode",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "email": email,
        "type": Number.parseInt(type),
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 手机登录
export function login(user, code, password) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/ajaxLoginUsers",
      async: false,
      dataType: 'jsonp',
      data: {
        "compid": COMID,
        "phonenumber": Number.parseInt(user),
        "regionnum": Number.parseInt(code),
        "password": password.toString()
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 邮箱登录
export function emailLogin(email, password) {
  return new Promise((resolve, reject) => {
    let LocalShoppingCart = JSON.parse(localStorage.getItem('LocalShoppingCart'))
    let detail = {}
    if (LocalShoppingCart) {
      for (let i = 0; i < LocalShoppingCart.length; i++) {
        detail[LocalShoppingCart[i].id] = LocalShoppingCart[i].sum;
      }
    }
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/emailLogin",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "email": email,
        "password": password,
        "detail": detail
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}


// 根据模块标志获取模块内容
export function getModelContent(sign) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getModelContent',
      type: 'post',
      dataType: 'jsonp',
      data: {
        compid: COMID,
        sign: sign
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 根据导航栏目id获取该导航下的所有的信息
export function getAllNavInfo(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getAllNavInfo',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID,
        navid: id
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 模板网站获取视频资料
export function etVideosData(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getVideosData',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

//获取商品分类
export function classify() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getAll',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 安装位置的产品列表
export function installationSiteOfProductList(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/installationSiteOfProductList',
      type: 'post',
      dataType: 'jsonp',
      data: {
        comid: COMID,
        i_id: id
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 获取网站的基本信息
export function baseInfo() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/baseInfo?comid=' + COMID,
      type: 'post',
      dataType: 'jsonp',
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}


// 对本地购物车数据封装
export function LocalShoppingCart(id, sum, xid, detail, index) {
  let data = JSON.parse(sessionStorage.getItem('LocalShoppingCart'));

  if (data) {
    if (Number.parseInt(sum) === 0) {
      data.splice(index, 1)
    }
    else {
      detail.id = id
      detail.sum = sum
      detail.xid = xid
      let has = false
      data.map((itme, i) => {
        if (itme.product_id === id) {
          has = true
          data.splice(i, 1, detail)
        }
      })
      if (!has) {
        data.push(detail)
      }
    }
    sessionStorage.setItem('LocalShoppingCart', JSON.stringify(data))
  }
  else {
    let shoppingarr = [];
    detail.id = id
    detail.sum = sum
    detail.xid = xid
    shoppingarr.push(detail)
    sessionStorage.setItem('LocalShoppingCart', JSON.stringify(shoppingarr))
  }
}


// 向购物车添加商品
export function sendLocahostSplus(detail) {

  // 用户操作商品时对登陆的有效期做判断，过去就调用退出函数

  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/addToCart',
      type: 'post',
      dataType: 'jsonp',
      data: {
        "uid": getLocahost('userID').user_id,
        'socket': getLocahost('userID').socket,
        'cpid': COMID,
        'detail': detail
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })

}

// 移除购物车的商品
export function delCart(detail) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/delCart',
      type: 'post',
      dataType: 'jsonp',
      data: {
        "uid": getLocahost('userID').user_id,
        'socket': getLocahost('userID').socket,
        'compid': COMID,
        'pid': detail
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })
}

//请求的购物车列表
export function cartList() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/cartList',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'uid': Number.parseInt(getLocahost('userID').user_id),
        'socket': getLocahost('userID').socket,
        'cpid': COMID
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })

}

// 对已加入购物车的商品做操作
export function changeSplus(id, num) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/modifyCartNum',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'uid': Number.parseInt(getLocahost('userID').user_id),
        'socket': getLocahost('userID').socket,
        'cpid': COMID,
        'num': num,
        'pid': id,
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })

}

// 购物车列表选择商品
export function cartSelectProduct(Detail) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/cartSelectProduct',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'uid': Number.parseInt(getLocahost('userID').user_id),
        'socket': getLocahost('userID').socket,
        'cpid': COMID,
        'detail': Detail
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })
}


// 商品结算
export function checkOut(detail) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/checkOut',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'uid': Number.parseInt(getLocahost('userID').user_id),
        'socket': getLocahost('userID').socket,
        'cpid': COMID,
        'detail': detail
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 提交订单
export function CommitOrder(data, pay) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/commitOrder',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'uid': Number.parseInt(getLocahost('userID').user_id),
        'socket': getLocahost('userID').socket,
        'cpid': COMID,
        'detail': data.Detail,
        'receive_user': data.consignee,
        'receive_phone': data.phone,
        'receive_address': data.address,
        'pay_way': pay
      },
      success: function (data) {
        resolve(data)
        if (data.code === 202) {
          cheacksocket()
        }
      },
      error: function () {
        reject(data)
      }
    })
  })
}

//无登录状态提交订单
export function commitOrderWithoutLogin(data, pay) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/commitOrderWithoutLogin',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'cpid': COMID,
        'detail': data.Detail,
        'receive_user': data.consignee,
        'receive_phone': data.phone,
        'receive_address': data.address,
        'pay_way': pay,
        'postalcode': data.Code
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

export function noLoginGetcommitReserve() {
  return new Promise((resolve, reject) => {
    let data = JSON.parse(localStorage.getItem('serviceDetail'))
    let Name = data.uname
    let Contact = data.phone
    let Email = data.mail
    let Date = data.date
    let Time = data.time
    let id = data.id
    this.sername = data.sername
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/commitReserveWithoutLogin',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'compid': COMID,
        'uname': Name.toString(),
        'phone': Contact.toString(),
        'mail': Email.toString(),
        'date': Date.toString(),
        'time': Time.toString(),
        'serviceid': Number.parseInt(id)
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 获取订单列表
export function OrdersList() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/ordersList',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'uid': Number.parseInt(getLocahost('logindata').user_id),
        'socket': getLocahost('logindata').socket,
        'cpid': COMID,
      },
      success: function (data) {
        resolve(data)
        // if(data.code===202){
        //     cheacksocket()
        // }
      },
      error: function () {
        reject(data)
      }
    })
  })
}


// 获取服务时间间隔信息
export function getServiceTimeIntervalInfo(extid, date) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getServiceTimeIntervalInfo',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'comid': COMID,
        'extid': extid,
        'date': date
      },
      // data:{
      //     'comid':37,
      //     'extid':8410
      // },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}


// 获取服务人员信息
export function getServicePersonnelInfo(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url + '/index.php/Api2/Ecustomers/getServicePersonnelInfo',
      type: 'post',
      dataType: 'jsonp',
      data: {
        'comid': COMID,
        'serviceid': data.id,
        'employeeid': data.users_id,
        'date': data.date,
        'time': data.time
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    })
  })
}

// 获取公司基本信息
export function getlink() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Getgift/getlink",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "entid": ENTID
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }

    });
  })
}

// 获取支付方式
export function paymentInterface() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/paymentInterface",
      async: false,
      dataType: 'jsonp',
      data: {
        "compid": COMID,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }

    });
  })
}

// 获取用户信息
export function getUserInfo(time_type) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/getUserInfo",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "flag": 'curtain',
        "time_type": time_type,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }

    });
  })
}

// 地区联动接口
export function getDeliveryAddressGroup(time_type, address_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/getDeliveryAddressGroup",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "address_id": address_id,
        "time_type": time_type,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }

    });
  })
}

// 产品安装位置
export function productInstallationSite(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/productInstallationSite",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
        "pid": id ? id : 0
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 产品计算公式
export function productFormula(obj) {
  obj.comid = COMID
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/productFormula",
      async: false,
      dataType: 'jsonp',
      data: obj,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 生成pdf
export function exportPdf(obj) {
  let pdfdata = {
    quotation_id: obj.quotation_id,
    company_id: COMID,
    quotation_code: obj.quotation_code,
    templates_id: obj.templates_id,
    templates_type: obj.templates_type,
  }
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/QuotationSheetPdf/exportPdf",
      async: true,
      crossDomain: true,
      dataType: 'json',
      data: {
        req: JSON.stringify(pdfdata),
      },
      success: function (data) {
        resolve(data)
      },
      error: function (e) {
        reject(e)
      }
    });
  })
}

// 删除pdf
export function delPdf(pdfurl) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/QuotationSheetPdf/delPdf",
      async: false,
      dataType: 'jsonp',
      data: {
        req: JSON.stringify({pdfUrl: pdfurl})
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

//  获取PDF模版数据
export function getSelectionTemplates(temp_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/ExportPdf/getSelectionTemplates",
      async: false,
      dataType: 'json',
      data: {
        req: JSON.stringify({
          company_id: COMID,
          field: temp_id,
        })
      },
      success: function (data) {
        resolve(data)
      },
      error: function (data) {
        reject(data)
      }
    });
  })
}


// 1.窗帘保存订单
export function commitOrderSave(data) {
  if (data.send_mail_flag === 1) {
    console.log('发送邮件')
    let pdfdata = {
      quotation_id: data.quotation_id,
      company_id: COMID,
      quotation_code: sessionStorage.getItem('quotation_code') ? sessionStorage.getItem('quotation_code') : data.quotation_code,
    }
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "post",
        url: url + "/index.php/Home/QuotationSheetPdf/exportPdf",
        async: true,
        crossDomain: true,
        dataType: 'json',
        data: {
          req: JSON.stringify(pdfdata),
        },
        success: function (pdf_file_path) {
          data.pdf_file_path = pdf_file_path
          $.ajax({
            type: "post",
            url: url + "/index.php/Api2/Ecustomers/commitOrderSave",
            async: true,
            crossDomain: true,
            dataType: 'json',
            data: data,
            success: function (data) {
              resolve(data)
            },
            error: function (e) {
              console.log(e)
              reject(e)
            }
          });
        },
        error: function (e) {
        }
      });
    })
  }
  else {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "post",
        url: url + "/index.php/Api2/Ecustomers/commitOrderSave",
        async: true,
        crossDomain: true,
        dataType: 'json',
        data: data,
        success: function (data) {
          resolve(data)
        },
        error: function (e) {
          console.log(e)
          reject(e)
        }
      });
    })
  }

}

// 1.窗帘编辑订单
export function commitOrderEdit(order_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/commitOrderEdit",
      async: true,
      crossDomain: true,
      dataType: 'jsonp',
      data: {
        order_id: order_id,
        // return_format: 'json',
      },
      success: function (data) {
        resolve(data)
      },
      error: function (e) {
        reject(e)
      }
    });
  })
}

// 获取窗帘订单列表
export function commitOrderList(p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/commitOrderList",
      async: false,
      dataType: 'jsonp',
      data: {
        enterprise_id: ENTID,
        company_id: COMID,
        custom_status: p_data.custom_status, //自定状态
        create_date_start: p_data.create_date_start, //创建日期开始
        create_date_end: p_data.create_date_end, //创建日期结束
        key_word: p_data.key_word, //关键词（范围：单号，备注，操作人名称）
        order_type: p_data.order_type, //訂單類型
        service_category: p_data.service_category, //服務類型
        title_name: p_data.title_name, //搜索的數據類型
        page: p_data.page, //頁數
        count: 20, //沒有顯示的條數
        page_type: 'paging', //分頁
        request_port : 'front_end', //區分app的字段
        page_classify: p_data.page_classify, //頁面類型
        // user_id: username
        user_id: p_data.userid
      },
      success: function (data) {
        resolve(data)
      },
      error: function (e) {
        reject(e)
      }
    });
  })
}

// 获取服务人员
export function getServiceUser() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "GET",
      url: url + "/index.php/ComApi/ServiceList/getServiceUser",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id: ENTID,
      },
      success: function (data) {
        resolve(data)
      },
      error: function (e) {
        reject(e)
      }
    });
  })
}

// 窗帘订单删除
export function commitOrderDel(order_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/commitOrderDel",
      async: false,
      dataType: 'jsonp',
      data: {
        order_id: order_id,
        user_id: Number.parseInt(getLocahost('logindata')),
      },
      success: function (data) {
        resolve(data)
      },
      error: function (e) {
        reject(e)
      }
    });
  })
}

// 获取安装方式
export function getInstallMode() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/getInstallMode",
      async: false,
      dataType: 'jsonp',
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 安装费
export function commitInstallationCharge() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/commitInstallationCharge",
      async: false,
      dataType: 'jsonp',
      data: {
        comid: COMID,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 根据购买产品数量动态获取价格
export function getProActionPrice(id, num) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/getProActionPrice",
      async: false,
      dataType: 'jsonp',
      data: {
        id: id,
        num: num,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 获取子产品(批量生成的子产品)
export function getSubproduct(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/getSubproduct",
      async: false,
      dataType: 'jsonp',
      data: {
        product_id: id,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 根据经纬度获取地理位置信息 ditu
export function geocode(latLngData) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: "https://www.google.cn/maps/api/geocode/json?latlng=" + latLngData + "&language=zh-HK&location_type=ROOFTOP&result_type=street_address&key=AIzaSyBcBxRmJQ9nObsLJ66FuQxjb5MTem_yOYE",
      async: true,
      success: function (data) {
        resolve(data)
      }
    });
  })
}


// 获取产品属性组合价格
export function getProductAttributeGroupPrice(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Product/getProductAttributeGroupPrice",
      async: false,
      dataType: 'jsonp',
      data: {
        product_id: id,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 订单上传附件
export function uploadFile(file) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/uploadFile",
      async: false,
      dataType: 'json',
      processData: false,
      contentType: false,
      data: file,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 删除订单附件
export function delOrderFile(id, file_path) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/delOrderFile",
      async: false,
      dataType: 'json',
      data: {
        id: id,
        file_path: file_path,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 获取员工信息（折扣信息）
export function getusersInfg() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/ComApi/Users/getusersInfo",
      async: false,
      dataType: 'json',
      data: {
        usersId: Number.parseInt(getLocahost('logindata')),
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 窗帘折扣审批申请
export function approval_discount(parameter) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/discount_approval_application",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id: ENTID,
        company_id: COMID,
        usersId: Number.parseInt(getLocahost('logindata')),
        order_id: parameter.order_id,
        order_amount: parameter.order_amount,
        discount: parameter.discount,
        remarks: parameter.remarks,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 窗帘订单增加支付金額
export function payment_money(parameter) {
  return new Promise((resolve, reject) => {
    let pdfdata = {
      quotation_id: sessionStorage.getItem('order_id'),
      company_id: COMID,
      quotation_code: sessionStorage.getItem('quotation_code') ? sessionStorage.getItem('quotation_code') : data.quotation_code,
    }
    //获取pdf
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/QuotationSheetPdf/exportPdf",
      async: true,
      crossDomain: true,
      dataType: 'json',
      data: {
        req: JSON.stringify(pdfdata),
      },
      success: function (pdf_file_path) {
        //提交订单
        $.ajax({
          type: "post",
          url: url + "/index.php/Api2/Ecustomers/payment_money",
          async: false,
          dataType: 'json',
          data: {
            usersId: Number.parseInt(getLocahost('logindata')),
            id: sessionStorage.getItem('order_id'),
            payment_note: parameter.payment_note,
            payment_money: parameter.payment_money,
            payment_document: parameter.payment_document,
            pdf_file_path: pdf_file_path,
            payment_date: getNowFormatDate(),
          },
          success: function (data) {
            resolve(data)
          },
          error: function (err) {
            reject(err)
          }
        });
      },
      error: function (e) {
      }
    });

  })
}

// 获取日期
function getNowFormatDate() {
  let date = new Date();
  let seperator1 = "-";
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  return (year + seperator1 + month + seperator1 + strDate)
}


// 电子签名
export function upload_electronic_signature(parameter) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/upload_electronic_signature",
      async: false,
      dataType: 'json',
      data: {
        id: parameter.id,
        file_base: parameter.file_base,
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}


// 采购单列表地址
export function purchase_order_exportPdf(parameter) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/PurchasePdf/exportPdf",
      async: false,
      dataType: 'json',
      data: {
        req: JSON.stringify({
          "purchase_id": parameter.purchase_id,
          "company_id": COMID,
          "purchase_code": parameter.purchase_code,
          "templates_id": parameter.templates_id
        })
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}


// 订单复制
export function orderCopy(order_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/orderCopy",
      async: false,
      dataType: 'json',
      data: {
        order_id: order_id
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 订单签署
export function orderSigned(order_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/orderSigned",
      async: false,
      dataType: 'json',
      data: {
        order_id: order_id
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 获取送货方式列表
export function getshippingMethodList() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/getshippingMethodList",
      async: false,
      dataType: 'json',
      data: {
        "companyid": COMID,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取产品分类
export function getProClassify() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/ComApi/Product/getProClassify",
      async: false,
      dataType: 'json',
      data: {
        "company_id": COMID,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 根据分类获取安装位置
export function getClassifyInstallationSite(classify_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/ComApi/Product/getClassifyInstallationSite",
      async: false,
      dataType: 'json',
      data: {
        "company_id": COMID,
        "classify_id": classify_id,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 購物車頁面的用戶選項顯示和隱藏
export function custom_page() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/custom_page",
      async: false,
      dataType: 'jsonp',
      data: {
        "comid": COMID,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 编辑保存员工（用户）信息
export function editSaveUsers(p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/ComApi/Users/editSaveUsers",
      async: false,
      dataType: 'json',
      data: {
        "users_id": Number.parseInt(getLocahost('logindata')),
        "socketCode": JSON.parse(localStorage.getItem('userdata')).socketCode,
        "users_username": p_data.users_username,
        "users_realname": p_data.users_realname,
        "users_areacode": p_data.users_areacode,
        "users_phone": p_data.users_phone,
        "users_telephone": p_data.users_telephone,
        "users_email": p_data.users_email,
        "users_address": p_data.users_address,
        "users_clinic": p_data.users_clinic,
        "users_fax": p_data.users_fax,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 獲取POS状态设定
export function getStateSetting() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/AppEcEat/PosOther/getStateSetting",
      async: false,
      dataType: 'json',
      data: {
        req: JSON.stringify({
          "usersId": Number.parseInt(getLocahost('logindata')),
          "socketCode": JSON.parse(localStorage.getItem('userdata')).socketCode,
          // "order_service_type": 1
        }),
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 獲取报价单状态设定
export function getStatusSettingData() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "get",
      url: url + "/index.php/Api2/Ecustomers/getStatusSettingData",
      async: false,
      dataType: 'json',
      data: {
        "user_id": Number.parseInt(getLocahost('logindata')),
        "socketCode": JSON.parse(localStorage.getItem('userdata')).socketCode,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 訂單列表修改自定義狀態
export function orderListEditSave(p_data) {
  p_data.user_id = Number.parseInt(getLocahost('logindata'))
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/orderListEditSave",
      async: false,
      dataType: 'json',
      data: p_data,
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 獲取設備列表
export function get_fixedassets_all_data(p_data={}) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/get_fixedassets_all_data",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id: ENTID,
        company_id: COMID,
        users_id: Number.parseInt(getLocahost('logindata')),
        assets_type: p_data.assets_type,
        title_name: p_data.title_name,
        keyword: p_data.keyword,
        page: p_data.page,
        limit:10,
        startTime: p_data.startTime,
        endTime: p_data.endTime,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取供应商数据
export function getSupplierData(role) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/getSupplierData",
      async: false,
      dataType: 'json',
      data: {
        user_id: Number.parseInt(getLocahost('logindata')),
        role: role,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 子公司資料（地址）
export function getSubCompany(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/getSubCompany",
      async: false,
      dataType: 'json',
      data: {
        // company_id:COMID,
        users_id: id || Number.parseInt(getLocahost('logindata')),
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 增加子公司資料（地址）
export function addSubcompany(data = {}) {
  data.users_id = Number.parseInt(getLocahost('logindata'))
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/addSubcompany",
      async: false,
      dataType: 'json',
      data: data,
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取订单类型数据
export function getOrderTypeData() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/getOrderTypeData",
      async: false,
      dataType: 'json',
      data: {
        "user_id": Number.parseInt(getLocahost('logindata')),
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 获取服务类别数据
export function getServiceCategoryData() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Ecustomers/getServiceCategoryData",
      async: false,
      dataType: 'json',
      data: {
        "user_id": Number.parseInt(getLocahost('logindata')),
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取客户管理
export function lis(p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/lis",
      async: false,
      dataType: 'json',
      data: {
        req: JSON.stringify(
          {
            usersId: Number.parseInt(getLocahost('logindata')),//用户id
            page: p_data.page || 1,//页码
            sort: '',//排序
            size: p_data.size || 10, //显示条数
            keyword: p_data.keywork, //关键字搜索   联络人名称  联络人手机号码  客户电话 联络人邮箱
            customer_userid: Number.parseInt(getLocahost('logindata')), //操作人员id
          }
        )
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 固定资产导出(設備管理),空白頁打開鏈接直接下載文件
export function export_execl_dow_url(assets_id_arr) {
  return url + "/index.php/ComApi/Fixedassets/export_execl?"+`enterprise_id=${ENTID}&company_id=${COMID}&users_id=${Number.parseInt(getLocahost('logindata'))}&assets_id=${assets_id_arr}`
}

// 固定资产导入模板下载
export function downloadTemplate() {
  return url + "/index.php/ComApi/Fixedassets/downloadTemplate"
}

// 固定资产导入(設備管理)
export function import_excel(file) {
  file.append('enterprise_id', ENTID)
  file.append('company_id', COMID)
  file.append('users_id', Number.parseInt(getLocahost('logindata')))
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/import_excel",
      async: false,
      dataType: 'json',
      processData: false,
      contentType: false,
      data: file,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 订单列表导入模板下载
export function orderdetails_downloadTemplate() {
  return url + "/index.php/ComApi/Quotation/downloadTemplate"
}

//订单列表导入
export function orderdetails_import_excel(file) {
  file.append('enterprise_id', ENTID)
  file.append('company_id', COMID)
  file.append('users_name', getLocahost_key('userdata').username)
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Quotation/import_excel",
      async: false,
      dataType: 'json',
      processData: false,
      contentType: false,
      data: file,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        reject(data)
      }
    });
  })
}

// 获取固定资产详情
export function get_fixedassets_detail(assets_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/get_fixedassets_detail",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id:ENTID,
        company_id:COMID,
        users_id: Number.parseInt(getLocahost('logindata')),
        assets_id: assets_id,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 固定资产添加/修改
export function add_fixedassets(p_data = {}) {
  p_data.enterprise_id = ENTID
  p_data.company_id = COMID
  p_data.users_id = Number.parseInt(getLocahost('logindata'))
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/add_fixedassets",
      async: false,
      dataType: 'json',
      data: p_data,
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}



// 产品品牌
export function get_brands() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/get_brands",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id:ENTID
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取设备类型
export function get_assets() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/get_assets",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id:ENTID
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 增加客戶公司p_data
export function add_customer_company(p_data = {}) {
  p_data.usersId = Number.parseInt(getLocahost('logindata'))
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/add",
      async: false,
      dataType: 'json',
      data: {
        req : JSON.stringify(p_data)
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// http请求函数,支持配置请求和响应参数
export function ajaxRequest(method, primary_url, type,p_data) {
  if (p_data){
    primary_url = url + `/index.php/Api2/Ecustomers/excelExportOrderListData?enterprise_id=${ENTID}&company_id=${COMID}&custom_status=${p_data.custom_status}&create_date_start=${p_data.create_date_start}&create_date_end=${p_data.create_date_end}&key_word=${p_data.key_word}&title_name=${p_data.title_name}&page=${p_data.page}&page_type=paging&request_port=front_end&page_classify=${p_data.page_classify}&user_id=${p_data.userid}`
  }
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.open(method, primary_url, true);
    req.responseType = type;
    req.onreadystatechange = () => {
      // readyState == 4说明请求已完成
      if (req.readyState === 4) {
        const data = req.response;
        // 获取文件名
        const content = req.getResponseHeader('Content-Disposition');
        const fileName = content && content.split(';')[1].split('filename=')[1];
        if (req.status === 200 || req.status === 304) {
          resolve({data, fileName});
        }
        else {
          reject(data);
        }
      }
    };
    // 发送数据
    req.send();
  });
}


// 获取省/市/区信息
export function getaddress(address_pid) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Customer/getaddress",
      async: false,
      dataType: 'json',
      data: {
        address_pid:address_pid //获取省信息传0,获取市/区信息传 地址id
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 根據訂單字段獲取每個設備的字段值
export function get_fixedassets_search_data(title_name) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/Fixedassets/get_fixedassets_search_data",
      async: false,
      dataType: 'json',
      data: {
        company_id:COMID,
        enterprise_id:ENTID,
        user_id: Number.parseInt(getLocahost('logindata')),
        title_name: title_name,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 訂單签署
export function contractSigning(order_id,flag) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Home/nodePer/contractSigning",
      async: false,
      dataType: 'json',
      data: {
        user_id: Number.parseInt(getLocahost('logindata')),
        flag: flag,
        order_id: order_id,
        quotation_id: order_id,
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 导出pdf库单数据
export function export_pdf(method, primary_url, type,order_id) {
  if (order_id){
    primary_url = url + `/index.php/ComApi/DetailLibrary/export_pdf?usersId=${Number.parseInt(getLocahost('logindata'))}&source_id=${order_id}`
  }
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.open(method, primary_url, true);
    req.responseType = type;
    req.onreadystatechange = () => {
      // readyState == 4说明请求已完成
      if (req.readyState === 4) {
        const data = req.response;
        // 获取文件名
        const content = req.getResponseHeader('Content-Disposition');
        const fileName = content && content.split(';')[1].split('filename=')[1];
        if (req.status === 200 || req.status === 304) {
          resolve({data, fileName});
        }
        else {
          reject(data);
        }
      }
    };
    // 发送数据
    req.send();
  });
}

// 获取国家
export function getcountrys() {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/getcountrys",
      async: false,
      dataType: 'json',
      data: {},
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取客戶詳情
export function getcompanyedit(company_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/getcompanyedit",
      async: false,
      dataType: 'json',
      data: {
        company_id:company_id
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取客户编号一级类型
export function getcustomer_num () {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/getcustomer_num",
      async: false,
      dataType: 'json',
      data: {
        users_enterprise_id:ENTID
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 一级类型获取二级类型及客户编号
export function getNumber2 (category_remark) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/getNumber2",
      async: false,
      dataType: 'json',
      data: {
        users_enterprise_id:ENTID,
        number_pid:category_remark
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 二级类型获取客户编号
export function getNum (pro,city) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/CustomerCompany/getNum",
      async: false,
      dataType: 'json',
      data: {
        users_enterprise_id:ENTID,
        pro:pro,
        city:city
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 获取联络人
export function customer (customer_id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/Api2/Sale/customer",
      async: false,
      dataType: 'json',
      data: {
        enterprise_id:ENTID,
        customer_id:customer_id,
        usersId: Number.parseInt(getLocahost('logindata'))
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 获取庫單
export function inventory_index (p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/AppEcEat/Inventory/inventory_index",
      async: false,
      dataType: 'json',
      data: {
        req:JSON.stringify({
          page:p_data.page,
          key_search:p_data.key_search,
          usersId: Number.parseInt(getLocahost('logindata'))
        })
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 編輯庫單
export function saveProductRemark (p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/AppEcEat/Inventory/saveProductRemark",
      async: false,
      dataType: 'json',
      data: {
        req:JSON.stringify({
          remark:p_data.remark,
          product_id:p_data.product_id,
          usersId: Number.parseInt(getLocahost('logindata'))
        })
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 庫單列表
export function showlist (p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/DetailLibrary/showlist",
      async: false,
      dataType: 'json',
      data: {
        req:JSON.stringify({
          usersId: Number.parseInt(getLocahost('logindata')),
          page : p_data.page || 1,
          type : 2, //出入库类型，1入库，2出库，3暂入，4暂出，5转仓，6退入，11退出
          library_status : p_data.library_status, //完成状态，1 未完成，2 完成
          lib_start_time  : new Date(p_data.startTime).getTime(), //搜索出入库开始时间(时间戳)
          lib_end_time   : new Date(p_data.endTime).getTime(), //搜索出入库结束时间
          key_word    : p_data.keyword, //搜索关键词
        })
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}


// 添加和編輯庫單
export function AccessLibrary (p_data) {
  p_data.usersId = Number.parseInt(getLocahost('logindata'))
  p_data.company_id  = COMID
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php/ComApi/DetailLibrary/AccessLibrary",
      async: false,
      dataType: 'json',
      data: {
        req:JSON.stringify(p_data)
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}

// 添加和編輯庫單
export function exportPdf_library (p_data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "post",
      url: url + "/index.php//Api2/ExportPdf/exportPdf",
      async: false,
      dataType: 'json',
      data: {
        req:JSON.stringify({
          usersId: Number.parseInt(getLocahost('logindata')),
          company_id: COMID,
          templates_id : p_data.templates_id,
          id : p_data.id,
          pdfType: 1,
        })
      },
      success: function (datas) {
        resolve(datas)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js